import Entity from '@/entities/entity'
import TransactionLog from './transaction-log'

export default class Dashboard extends Entity<number> {
  totalTrip?: number
  totalStoreDelivery?: number
  tripDelivered?: number
  received?: number
  totalMove?: number
  totalReturn?: number
  moveDelivered?: number
  returned?: number
  latestActivities?: TransactionLog
  moveDeliveredRate? :number
  receivedRate? :number
  tripDeliveredRate? :number
  returnedRate? :number
}
